export function getCookie(name) {
  if (!name) return name;
  const prefix = `${name}=`;
  return document.cookie
    ?.split(';')
    .find((x) => x.trim().startsWith(prefix))
    ?.trim()
    .slice(prefix.length);
}

export function addCookie(name, value) {
  document.cookie = `${name}=${value};path=/;`;
}

export function deleteCookie(name) {
  document.cookie = `${name}=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
}
